import { Typography, styled } from '@mui/material';

const NotFoundText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.neutral.dark
}));

export default NotFoundText;
